angular.module('qkr').controller('loyaltyController', ($scope, $uibModal, $timeout, $filter, utils, loyaltyService,
                                                       inventoryService, merchantService, analyticsService,
                                                       gettextCatalog, appConfig) => {
    $scope.merchantInfo = null;
    $scope.display = {};
    $scope.display.showDiscountControl = false;
    $scope.display.discountAmountMinorUnits = 0;
    $scope.display.points;
    $scope.display.isActiveRewardTierPresent = false;
    $scope.recalculateProgressBarsTimeout = null;
    $scope.roundTo = 1;
    $scope.roundToForMinorUnits = $scope.roundTo + 2;
    $scope.rewardScheme = null;
    $scope.loaded = false;
    $scope.productList = [];
    $scope.savingScheme = false;

    $scope.loyaltymetrics = [];

    $scope.init = function() {
        merchantService.loadMerchantInfo().then((promise) => {
            $scope.merchantInfo = promise;
        });

        loyaltyService.getRewardScheme().then((promise) => {
            $scope.rewardScheme = promise.data;
            $scope.display.points = $scope.rewardScheme.earnRatePerMinorUnit * 100;

            if ($scope.rewardScheme.rewardSchemeTiers == null) {
                $scope.rewardScheme.rewardSchemeTiers = [];
            }
            inventoryService.loadInventory().then((promise) => {
                $scope.productList = promise;

                angular.forEach($scope.rewardScheme.rewardSchemeTiers, (rewardSchemeTier) => {
                    if (rewardSchemeTier.discountAmountMinorUnits) {
                        rewardSchemeTier.label = 'Discount';
                        rewardSchemeTier.icon = 'fa fa-lg fa-money';
                    } else {
                        rewardSchemeTier.label = generateProductRewardLabel(rewardSchemeTier.productIds);
                        rewardSchemeTier.icon = 'fa fa-gift';
                    }
                    rewardSchemeTier.deleted = false;
                    rewardSchemeTier.deletedStyle = '';
                    rewardSchemeTier.deletedIcon = 'fa fa-lg fa-trash-o';
                    rewardSchemeTier.open = true;
                    $scope.display.isActiveRewardTierPresent = true;
                });
                
                if (!$scope.display.isActiveRewardTierPresent) {
                	$scope.isEdit = true;
                }
            });

            $scope.recalculateDetails();

            $scope.setArrow('label', false);

            if ($scope.rewardScheme.id) {
                $scope.hasLoyalty = true;
            }

            $scope.loaded = true;
        });

        $scope.showOverview = false;

        analyticsService.getCoreLoyaltyMetrics().then((promise) => {
            $.each(promise.data, (index, value) => {
                if (value.metric == 'loyaltyVsNonLoyaltyCustomerSpendPercentKPI') {
                    $scope.loyaltymetrics.loyaltyVsNonLoyaltyCustomerSpendPercentKPI = value.kpiValue;
                }

                if (value.metric == 'loyaltyTotalCostOfRewardsClaimedKPI') {
                    $scope.loyaltymetrics.loyaltyTotalCostOfRewardsClaimedKPI = value.kpiValue;
                }

                if (value.metric == 'loyaltyUsersVsTotalUsersPercentKPI') {
                    $scope.loyaltymetrics.loyaltyUsersVsTotalUsersPercentKPI = value.kpiValue;
                }

                if (value.metric == 'loyaltyCostOfRewardsVsTotalSalesPercentKPI') {
                    $scope.loyaltymetrics.loyaltyCostOfRewardsVsTotalSalesPercentKPI = value.kpiValue;
                }

                if (value.metric == 'loyaltyCustomersPerTierKPI') {
                    var tierId = value.kpiIdentifier.identifiers.tierId;
                    angular.forEach($scope.rewardScheme.rewardSchemeTiers, (tier, key) => {
                        if (tier.id == tierId) {
                            tier.customers = value.kpiValue;
                        }
                    });
                }

                if (value.metric == 'loyaltyRedemptionsPerTierKPI') {
                    var tierId = value.kpiIdentifier.identifiers.tierId;
                    angular.forEach($scope.rewardScheme.rewardSchemeTiers, (tier, key) => {
                        if (tier.id == tierId) {
                            tier.redemptionPercent = value.kpiValue;
                        }
                    });
                }
            });
        });
    };

    $scope.initialiseLoyalty = function() {
        if (!$scope.validateDisplayPoints()) {
            return;
        }
        
        const addRewardSchemeCommand = {};
        addRewardSchemeCommand.earnRatePerMinorUnit = $scope.rewardScheme.earnRatePerMinorUnit;

        loyaltyService.addRewardScheme(addRewardSchemeCommand).then((promise) => {
            $scope.rewardScheme.id = promise.data.id;
            $scope.hasLoyalty = true;
            $scope.isEdit = true;
        });
    };

    $scope.removeRewardTier = function(rewardTier) {
        rewardTier.deleted = !rewardTier.deleted;

        if (rewardTier.deleted) {
            rewardTier.deletedStyle = {
                opacity: 0.4
            };
            rewardTier.deletedIcon = 'fa fa-lg fa-undo';
        } else {
            rewardTier.deletedStyle = '';
            rewardTier.deletedIcon = 'fa fa-lg fa-trash-o';
        }
    };

    $scope.openRewardProductsModal = function(rewardTier) {
        let preSelectedProducts = [];

        if (rewardTier != null) {
            preSelectedProducts = rewardTier.productIds;
        }

        const modalInstance = $uibModal.open({
            template: require('../templates/loyalty/rewardProduct.html'),
            controller: 'rewardProductController',
            windowClass: 'modal-huge',
            backdrop: 'static',
            resolve: {
                preSelectedProducts() {
                    return preSelectedProducts;
                },

                productList() {
                    return $scope.productList;
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result != 'cancel') {
                const selectedFields = result;
                let label = '';
                const selectedProducts = [];
                let maxPrice = 0;

                // Loops through cat then prod then variant
                // Skips to next itteration if selected
                // First pushes products
                // Second set max price
                // Third set label if needs too
                for (let c = 0; c < selectedFields.length; c++) {
                    if (selectedFields[c].selected) {
                        angular.forEach(selectedFields[c].products, (product) => {
                            const newId = {
                                id: product.id
                            };
                            selectedProducts.push(newId);
                            if (product.maximumVariantPrice > maxPrice) {
                                maxPrice = product.maximumVariantPrice;
                            }
                        });
                        continue;
                    }
                    for (let p = 0; p < selectedFields[c].products.length; p++) {
                        if (selectedFields[c].products[p].selected) {
                            const newId = {
                                id: selectedFields[c].products[p].id
                            };
                            selectedProducts.push(newId);
                            if (selectedFields[c].products[p].maximumVariantPrice > maxPrice) {
                                maxPrice = selectedFields[c].products[p].maximumVariantPrice;
                            }

                            continue;
                        }
                        // For (var v = 0; v <
                        // SelectedFields[c].products[p].variants.length; v++) {
                        // If
                        // (selectedFields[c].products[p].variants[v].selected)
                        // {
                        // //change me
                        // SelectedFields[c].products[p].variants[v].name =
                        // SelectedFields[c].products[p].variants[v].id;
                        // If
                        // (selectedProducts.indexOf(selectedFields[c].products[p].variants[v].inheritedProduct)
                        // == -1) {
                        // SelectedProducts.push(selectedFields[c].products[p].variants[v].inheritedProduct);
                        // }
                        // If(selectedFields[c].products[p].variants[v].amountMinorUnits
                        // > maxPrice){
                        // MaxPrice =
                        // SelectedFields[c].products[p].variants[v].amountMinorUnits;
                        // }
                        // If (label.length == 0) {
                        // Label =
                        // SelectedFields[c].products[p].variants[v].inheritedProduct;
                        // }
                        //
                        // Continue;
                        // }
                        // }
                    }
                }

                label = generateProductRewardLabel(selectedProducts);

                const newRewardTier = addNewRewardProductTier(label, maxPrice);

                newRewardTier.productIds = selectedProducts;

                newRewardTier.open = true;

                if (rewardTier != null) {
                    for (let i = 0; i < $scope.rewardScheme.rewardSchemeTiers.length; i++) {
                        if ($scope.rewardScheme.rewardSchemeTiers[i].id == rewardTier.id) {
                            newRewardTier.id = rewardTier.id;
                            $scope.rewardScheme.rewardSchemeTiers[i] = angular.copy(newRewardTier);
                            break;
                        }
                    }
                } else {
                    // TEMP
                    // NewRewardTier.id =
                    // $scope.rewardScheme.rewardSchemeTiers.length;
                    $scope.rewardScheme.rewardSchemeTiers.push(newRewardTier);
                }

                $scope.recalculateDetailsProxy();
                $scope.display.discountAmountMinorUnits = 0;
                $scope.display.isActiveRewardTierPresent = true;

                // Check to see how it looks on overview
                calculateForOverview($scope.rewardScheme.rewardSchemeTiers[$scope.rewardScheme.rewardSchemeTiers.length - 1]);
            }
        }, () => {
        });
    };

    $scope.showDiscountControl = function() {
        $scope.display.showDiscountControl = true;
    };

    $scope.confirmDiscount = function() {
        if (!$scope.validateAddDiscount()) {
            return;
        }

        $scope.display.showDiscountControl = false;

        const rewardTier = {};
        rewardTier.discountAmountMinorUnits = $scope.display.discountAmountMinorUnits;

        const pointsThreshold = (rewardTier.discountAmountMinorUnits * $scope.rewardScheme.earnRatePerMinorUnit);
        rewardTier.pointsThreshold = utils.roundNumberToSpecifiedDecimalPlaces(pointsThreshold, $scope.roundTo) * 10;

        rewardTier.equivalentReturnForCustomer = $scope.calculateEquivalentReturnForCustomer(rewardTier);
        rewardTier.equivalentSpendForCustomer = $scope.calculateEquivalentSpendForCustomer(rewardTier);

        rewardTier.label = 'Discount';
        rewardTier.icon = 'fa fa-lg fa-money';

        rewardTier.deleted = false;
        rewardTier.deletedStyle = '';
        rewardTier.deletedIcon = 'fa fa-lg fa-trash-o';

        rewardTier.id = null;

        rewardTier.description = generateRewardTierDescription(rewardTier);
        $scope.rewardScheme.rewardSchemeTiers.push(rewardTier);

        rewardTier.open = true;

        $scope.recalculateDetailsProxy();
        $scope.display.discountAmountMinorUnits = 0;
        $scope.display.isActiveRewardTierPresent = true;

        calculateForOverview($scope.rewardScheme.rewardSchemeTiers[$scope.rewardScheme.rewardSchemeTiers.length - 1]);
    };

    $scope.recalculateDetailsProxy = function() {
        if ($scope.recalculateProgressBarsTimeout != null) {
            $timeout.cancel($scope.recalculateProgressBarsTimeout);
        }

        $scope.recalculateProgressBarsTimeout = $timeout(() => {
            $scope.recalculateDetails();
        }, 1000);
    };

    $scope.recalculateDetails = function() {
        let max = 0;

        angular.forEach($scope.rewardScheme.rewardSchemeTiers, (rewardTier) => {
            if (!rewardTier.deleted) {
                if (max < Number(rewardTier.pointsThreshold)) {
                    max = Number(rewardTier.pointsThreshold);
                }
            }
        });

        angular.forEach($scope.rewardScheme.rewardSchemeTiers, (rewardTier) => {
            rewardTier.pointsThresholdAsPercentageOfTotal = (rewardTier.pointsThreshold / max) * 100;
            rewardTier.equivalentReturnForCustomer = $scope.calculateEquivalentReturnForCustomer(rewardTier);
            rewardTier.equivalentSpendForCustomer = $scope.calculateEquivalentSpendForCustomer(rewardTier);
        });
    };

    $scope.changePointsThreshold = function(rewardTier, value) {
        const newVal = Number(rewardTier.pointsThreshold) + Number(value);

        if (newVal >= 0) {
            rewardTier.pointsThreshold = newVal;
            $scope.recalculateDetailsProxy();
        }
    };

    $scope.calculateEquivalentReturnForCustomer = function(rewardTier) {
        return accounting.toFixed(((rewardTier.discountAmountMinorUnits * $scope.rewardScheme.earnRatePerMinorUnit) / rewardTier.pointsThreshold) * 100, 1);
    };

    $scope.calculateEquivalentSpendForCustomer = function(rewardTier) {
        return accounting.toFixed((rewardTier.pointsThreshold / $scope.rewardScheme.earnRatePerMinorUnit), 2);
    };

    $scope.updatePointsPerMinorUnit = function() {
        if ($scope.validateDisplayPoints()) {
            const oldPointsPerMinorUnit = angular.copy($scope.rewardScheme.earnRatePerMinorUnit);
            $scope.rewardScheme.earnRatePerMinorUnit = utils.roundNumberToSpecifiedDecimalPlaces($scope.display.points / 100, $scope.roundToForMinorUnits);
            $scope.recalculateDetails();
        }
    };

    $scope.activateOrDeactivateRewardScheme = function() {
        if ($scope.rewardScheme.isActive) {
            confMsg = gettextCatalog.getString('Are you sure you would like to suspend the loyalty program?');
            title = gettextCatalog.getString('Suspend Loyalty Program');
        } else {
            confMsg = gettextCatalog.getString('Are you sure you would like to reactivate the loyalty program?');
            title = gettextCatalog.getString('Reactivate Loyalty Program');
        }

        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return title;
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Confirm');
                },
                confirmMsg() {
                    return confMsg;
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result == 'ok') {
                // Function here
                let activate = false;
                if (!$scope.rewardScheme.isActive) {
                    activate = true;
                }

                loyaltyService.activateOrDeactivateRewardScheme(activate).then((result) => {
                	$scope.rewardScheme.isActive = result.data.isActive;
                });
            }
        }, () => {
        });
    };

    $scope.validateDisplayPoints = function() {
    	$scope.setPointsPerErrors = null;
        let valid = true;
        const errors = {};

        if (utils.hasNoValue($scope.display.points)) {
            errors.setPointsPer = gettextCatalog.getString('Please enter a points value');
            valid = false;
        } else if ($scope.display.points <= 0) {
            errors.setPointsPer = gettextCatalog.getString('Please enter a positive points value');
            valid = false;
        } else if ($scope.display.points > 100) {
            errors.setPointsPer = gettextCatalog.getString('Points earned cannot be over 100');
            valid = false;
        }
        
        if (valid) {
        	const floored = utils.floorNumberToSpecifiedDecimalPlaces($scope.display.points, $scope.roundTo);
            const difference = floored - $scope.display.points;

            const place = ($scope.roundTo != 1) ? gettextCatalog.getString('places') : gettextCatalog.getString('place');

            if (difference != 0) {
            	errors.setPointsPer = gettextCatalog.getString('Points earned cannot have more than') + ' ' + $scope.roundTo + ' ' + gettextCatalog.getString('decimal') + ' ' + place;
                valid = false;
            }
        }
        
        $scope.setPointsPerErrors = errors;
        return valid;
    };

    $scope.confirmRewardSchemeChanges = function() {
        if (!$scope.validateConfirmChanges()) {
            return;
        }
        
        const title = gettextCatalog.getString('Confirm Changes');
        const confMsg = gettextCatalog.getString('Are you sure you would like to confirm these changes?');

        const modalInstance = $uibModal.open({
            template: require('../templates/common/modalDialog.html'),
            controller: 'commonModalDialogController',
            windowClass: 'fade',
            backdrop: 'static',
            resolve: {
                title() {
                    return title;
                },
                confirmButtonName() {
                    return gettextCatalog.getString('Confirm');
                },
                confirmMsg() {
                    return confMsg;
                },
                multiMsgArray() {
                    return [];
                }
            }
        });

        modalInstance.result.then((result) => {
            if (result == 'ok') {
                $scope.savingScheme = true;

                const updateRewardSchemeCommand = {};
                updateRewardSchemeCommand.id = $scope.rewardScheme.id;
                updateRewardSchemeCommand.earnRatePerMinorUnit = $scope.rewardScheme.earnRatePerMinorUnit;
                updateRewardSchemeCommand.addRewardSchemeTiers = getAddRewardSchemeTierCommands();
                updateRewardSchemeCommand.updateRewardSchemeTiers = getUpdateRewardSchemeTierCommands();
                updateRewardSchemeCommand.removeRewardSchemeTierIds = getRemoveRewardSchemeTierIds();

                loyaltyService.updateRewardScheme(updateRewardSchemeCommand).then((promise) => {
                    const newRewardSchemeTiers = angular.copy(promise.data.rewardSchemeTiers);
                    const nonDeletedRewardTiers = [];

                    angular.forEach(newRewardSchemeTiers, (newRewardSchemeTier) => {
                        if (newRewardSchemeTier.discountAmountMinorUnits) {
                            newRewardSchemeTier.label = 'Discount';
                            newRewardSchemeTier.icon = 'fa fa-lg fa-money';
                        } else {
                            newRewardSchemeTier.label = generateProductRewardLabel(newRewardSchemeTier.productIds);
                            newRewardSchemeTier.icon = 'fa fa-gift';
                        }
                        newRewardSchemeTier.deleted = false;
                        newRewardSchemeTier.deletedStyle = '';
                        newRewardSchemeTier.deletedIcon = 'fa fa-lg fa-trash-o';
                        newRewardSchemeTier.open = true;

                        $scope.display.isActiveRewardTierPresent = true;
                        $scope.isEdit = false;
                        $scope.savingScheme = false;

                        nonDeletedRewardTiers.push(newRewardSchemeTier);
                    });

                    $scope.rewardScheme.rewardSchemeTiers = angular.copy(nonDeletedRewardTiers);
                    $scope.recalculateDetails();
                });
            }
        }, () => {
        });
    };

    $scope.cancelRewardSchemeChanges = function() {
        $scope.savingScheme = true;

        loyaltyService.getRewardScheme().then((promise) => {
            $scope.rewardScheme = promise.data;

            $scope.display.points = $scope.rewardScheme.earnRatePerMinorUnit * 100;

            if ($scope.rewardScheme.rewardSchemeTiers == null) {
                $scope.rewardScheme.rewardSchemeTiers = [];
            }

            angular.forEach($scope.rewardScheme.rewardSchemeTiers, (rewardSchemeTier) => {
                if (rewardSchemeTier.discountAmountMinorUnits) {
                    rewardSchemeTier.label = 'Discount';
                    rewardSchemeTier.icon = 'fa fa-lg fa-money';
                } else {
                    rewardSchemeTier.label = generateProductRewardLabel(rewardSchemeTier.productIds);
                    rewardSchemeTier.icon = 'fa fa-gift';
                }
                rewardSchemeTier.deleted = false;
                rewardSchemeTier.deletedStyle = '';
                rewardSchemeTier.deletedIcon = 'fa fa-lg fa-trash-o';
                rewardSchemeTier.open = true;
                $scope.display.isActiveRewardTierPresent = true;
            });

            $scope.recalculateDetails();

            $scope.setArrow('label', false);

            $scope.isEdit = false;

            $scope.savingScheme = false;
        });
    };

    var getAddRewardSchemeTierCommands = function() {
        const rewardSchemeTiersToBeAdded = [];
        angular.forEach($scope.rewardScheme.rewardSchemeTiers, (rewardSchemeTier) => {
            if (utils.hasNoValue(rewardSchemeTier.id)) {
                const addRewardSchemeTierCommand = {};
                addRewardSchemeTierCommand.pointsThreshold = Number(rewardSchemeTier.pointsThreshold);

                if (rewardSchemeTier.label == 'Discount') {
                    addRewardSchemeTierCommand.description = rewardSchemeTier.description;
                    addRewardSchemeTierCommand.discountAmountMinorUnits = Number(rewardSchemeTier.discountAmountMinorUnits);
                    delete (addRewardSchemeTierCommand.productIds);
                } else {
                    delete (addRewardSchemeTierCommand.discountAmountMinorUnits);
                    addRewardSchemeTierCommand.description = rewardSchemeTier.label;
                    addRewardSchemeTierCommand.productIds = [];

                    const productIds = [];
                    angular.forEach(rewardSchemeTier.productIds, (productId) => {
                        productIds.push(productId);
                    });

                    addRewardSchemeTierCommand.productIds = productIds;
                }
                rewardSchemeTiersToBeAdded.push(addRewardSchemeTierCommand);
            }
        });

        return rewardSchemeTiersToBeAdded;
    };

    var getUpdateRewardSchemeTierCommands = function() {
        const rewardSchemeTiersToBeUpdated = [];

        angular.forEach($scope.rewardScheme.rewardSchemeTiers, (rewardSchemeTier) => {
            if (rewardSchemeTier.id != null && rewardSchemeTier.deleted != true) {
                const updateRewardSchemeTierCommand = {};
                updateRewardSchemeTierCommand.id = rewardSchemeTier.id;
                updateRewardSchemeTierCommand.pointsThreshold = Number(rewardSchemeTier.pointsThreshold);

                if (rewardSchemeTier.label == 'Discount') {
                    updateRewardSchemeTierCommand.description = rewardSchemeTier.description;
                    updateRewardSchemeTierCommand.discountAmountMinorUnits = Number(rewardSchemeTier.discountAmountMinorUnits);
                    delete (updateRewardSchemeTierCommand.productIds);
                } else {
                    delete (updateRewardSchemeTierCommand.discountAmountMinorUnits);
                    updateRewardSchemeTierCommand.description = rewardSchemeTier.label;

                    const productIds = [];
                    angular.forEach(rewardSchemeTier.productIds, (productId) => {
                        productIds.push(productId);
                    });

                    updateRewardSchemeTierCommand.productIds = productIds;
                }
                rewardSchemeTiersToBeUpdated.push(updateRewardSchemeTierCommand);
            }
        });

        return rewardSchemeTiersToBeUpdated;
    };

    var getRemoveRewardSchemeTierIds = function() {
        const rewardSchemeTierIdsToBeRemoved = [];

        angular.forEach($scope.rewardScheme.rewardSchemeTiers, (rewardSchemeTier) => {
            if (rewardSchemeTier.deleted && rewardSchemeTier.id != null) {
                const rewardSchemeTierId = {
                    id: rewardSchemeTier.id
                };
                rewardSchemeTierIdsToBeRemoved.push(rewardSchemeTierId);
            }
        });

        return rewardSchemeTierIdsToBeRemoved;
    };

    var addNewRewardProductTier = function(displayLabel, maxPrice) {
        const rewardTier = {};
        rewardTier.label = displayLabel;

        rewardTier.discountAmountMinorUnits = maxPrice;

        const pointsThreshold = (rewardTier.discountAmountMinorUnits * $scope.rewardScheme.earnRatePerMinorUnit);

        rewardTier.pointsThreshold = utils.roundNumberToSpecifiedDecimalPlaces(pointsThreshold, $scope.roundTo) * 10;

        rewardTier.equivalentReturnForCustomer = $scope.calculateEquivalentReturnForCustomer(rewardTier);
        rewardTier.equivalentSpendForCustomer = $scope.calculateEquivalentSpendForCustomer(rewardTier);

        rewardTier.icon = 'fa fa-gift';

        rewardTier.deleted = false;
        rewardTier.deletedStyle = '';
        rewardTier.deletedIcon = 'fa fa-lg fa-trash-o';

        rewardTier.id = null;

        return rewardTier;
    };

    // Just for testing. Used to see that rewardTiers are showing up correctly
    // On overview page
    var calculateForOverview = function(tier) {
        tier.customers = Math.floor((Math.random() * 1000) + 1);
        tier.redemptionPercent = Math.floor((Math.random() * 100));
    };

    var generateRewardTierDescription = function(rewardTier) {
        if (rewardTier.discountAmountMinorUnits != null) {
            const currencySymbol = $filter('currencySymbol')($scope.merchantInfo.defaultCurrency);
            const discountCurrencyDescription = $filter('currency')(rewardTier.discountAmountMinorUnits / 100, currencySymbol);
            return discountCurrencyDescription + ' Discount';
        } else {
            // Gen description for products
            return '';
        }
    };

    var generateProductRewardLabel = function(selectedProductIds) {
        let newLabel = '';
        for (let p = 0; p < $scope.productList.length; p++) {
            if (selectedProductIds[0].id == $scope.productList[p].id) {
                newLabel = $scope.productList[p].name;
                if (selectedProductIds.length > 1) {
                    newLabel = newLabel + ' ( + ' + (selectedProductIds.length - 1) + ' more )';
                }
                break;
            }
        }
        return newLabel;
    };

    $scope.setArrow = function(active, reverse) {
        $scope.labelArrow = 'fa fa-sort';
        $scope.pointsThresholdArrow = 'fa fa-sort';
        $scope.equivalentReturnForCustomerArrow = 'fa fa-sort';

        switch (active) {
            case ('label') :
                if (reverse) {
                    $scope.labelArrow = 'fa fa-sort-up';
                } else {
                    $scope.labelArrow = 'fa fa-sort-down';
                }
                break;
            case ('pointsThreshold') :
                if (reverse) {
                    $scope.pointsThresholdArrow = 'fa fa-sort-up';
                } else {
                    $scope.pointsThresholdArrow = 'fa fa-sort-down';
                }
                break;
            case ('equivalentReturnForCustomer') :
                if (reverse) {
                    $scope.equivalentReturnForCustomerArrow = 'fa fa-sort-up';
                } else {
                    $scope.equivalentReturnForCustomerArrow = 'fa fa-sort-down';
                }
                break;
        }
    };

    $scope.recalculatePointsThreshold = function(pointsThreshold, step) {
        let result = pointsThreshold - (pointsThreshold % step);
        result = utils.roundNumberToSpecifiedDecimalPlaces(result, utils.getNumberOfDecimalPlaces(step));
        return result;
    };

    $scope.editTiers = function() {
        $scope.isEdit = true;
    };

    $scope.validateAddDiscount = function() {
        $scope.addDiscountErrors = null;
        let valid = true;
        const errors = {};
            
        if (utils.hasNoValue($scope.display.discountAmountMinorUnits)) {
            errors.setPointsPer = gettextCatalog.getString('Please enter a discount');
            valid = false;
        } else if ($scope.display.discountAmountMinorUnits <= 0) {
            errors.setPointsPer = gettextCatalog.getString('Please enter a positive discount');
            valid = false;
        }
            
        $scope.addDiscountErrors = errors;

        return valid;
    };
    
    $scope.validateConfirmChanges = function() {
        let valid = true;
        const errors = {};
            
        angular.forEach($scope.rewardScheme.rewardSchemeTiers, (rewardTier) => {
            rewardTier.errors = null;
            const errors = {};
            
            if (rewardTier.label == 'Discount') {
                if (utils.hasNoValue(rewardTier.discountAmountMinorUnits)) {
                    errors.label = gettextCatalog.getString('Discounts cannot be empty');
                    valid = false;
                } else if (rewardTier.discountAmountMinorUnits <= 0) {
                    errors.label = gettextCatalog.getString('Discounts must be positive');
                    valid = false;
                }
            }
            
            if (utils.hasNoValue(rewardTier.pointsThreshold)) {
                errors.pointsThreshold = gettextCatalog.getString('Points threshold cannot be empty');
                valid = false;
            } else if (rewardTier.pointsThreshold <= 0) {
                errors.pointsThreshold = gettextCatalog.getString('Points threshold must be positive');
                valid = false;
            }
                        
            rewardTier.errors = errors;
        });
        
        valid = valid && $scope.validateDisplayPoints();

        return valid;
     };
});



// WEBPACK FOOTER //
// ./src/controllers/loyalty.controller.js